import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import { Bot, PlayCircle, Phone, PhoneCall } from 'lucide-react';
import AIVoiceMonitor from '../Operator/AIVoiceMonitor';
import AIVoiceSimulator from '../Operator/AIVoiceSimulator';
import VoiceCalls from '../VoiceCalls';
import VoIPCaller from '../../CRM/VoIPCaller';
import { useBusiness } from '../../../contexts/BusinessContext';

const AIVoice = () => {
  const { currentBusiness } = useBusiness();

  return (
    <div className="flex-1 h-full bg-gradient-to-br from-white via-green-50 to-purple-50">
      {/* Header */}
      <div className="p-6 bg-white/80 backdrop-blur-sm border-b border-gray-200">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">AI Voice</h1>
          <p className="text-gray-600">Voice AI monitoring, simulation, and VoIP management</p>
        </div>
      </div>

      {/* Tabs */}
      <Tabs defaultValue="monitor" className="flex-1 flex flex-col">
        <div className="p-4 bg-white/80 backdrop-blur-sm border-b border-gray-200">
          <TabsList className="grid w-full max-w-2xl grid-cols-4">
            <TabsTrigger value="monitor">
              <Bot className="h-4 w-4 mr-2" />
              AI Voice Monitor
            </TabsTrigger>
            <TabsTrigger value="simulator">
              <PlayCircle className="h-4 w-4 mr-2" />
              AI Voice Simulator
            </TabsTrigger>
            <TabsTrigger value="calls">
              <Phone className="h-4 w-4 mr-2" />
              Voice Calls
            </TabsTrigger>
            <TabsTrigger value="voip">
              <PhoneCall className="h-4 w-4 mr-2" />
              CRM VoIP
            </TabsTrigger>
          </TabsList>
        </div>

        {/* AI Voice Monitor Tab */}
        <TabsContent value="monitor" className="flex-1 m-0">
          <AIVoiceMonitor businessId={currentBusiness?.brandId || ''} />
        </TabsContent>

        {/* AI Voice Simulator Tab */}
        <TabsContent value="simulator" className="flex-1 m-0">
          <AIVoiceSimulator />
        </TabsContent>

        {/* Voice Calls Tab */}
        <TabsContent value="calls" className="flex-1 m-0">
          <VoiceCalls />
        </TabsContent>

        {/* CRM VoIP Tab */}
        <TabsContent value="voip" className="flex-1 m-0">
          <VoIPCaller />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AIVoice;
